export default "__VITE_ASSET__Bh9ESL_k__"